import { FEATURE_FLAGS } from "../../../constants/featureFlags";
import { getUserData } from "../../../services/API";

// react-i18next me
const metrics = [
  {
    label: 'Amira Reading Mastery (ARM)',
    value: 'ARM',
    scales: [
      {
        value: 'ARM',
        label: 'Amira Reading Mastery (ARM)',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
    ],
    description: '',
  },
  {
    label: 'Oral Reading Fluency (ORF)',
    value: 'ORF',
    scales: [
      {
        value: 'WCPM',
        label: 'Words Correct Per Minute (WCPM)',
      },
      {
        value: 'Lexile',
        label: 'Lexile measure (based on grade equivalency)',
      },
      {
        value: 'DRA',
        label: 'Developmental Reading Assessment',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: '',
  },
  {
    label: 'High Frequency Words',
    value: 'SightRecognition',
    scales: [
      {
        value: 'ESRI',
        label: 'EHFWI'
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: ''
  },
  {
    label: 'Phonological Awareness',
    value: 'PhonologicalAwareness',
    scales: [
      {
        value: 'PSF',
        label: 'PSF'
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: ''
  },
  {
    label: 'Vocabulary Size',
    value: 'VocabSize',
    scales: [
      {
        value: 'EVS',
        label: 'Estimated Words in Vocabulary',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: '',
  },
];

export const comprehensiveAssessmentMetrics = [
  {
    label: 'Nonsense Word Fluency',
    value: 'NWF',
    scales: [
      {
        value: 'nwfCorrect',
        label: '# of Correct Answers',
      },
    ],
    benchmarks: [],
    description: '',
  },
  {
    label: 'Spelling (Encoding)',
    value: 'Spelling',
    scales: [
      {
        value: 'spellingCorrect',
        label: '# of Correct Answers',
      },
    ],
    benchmarks: [],
    description: '',
  },
]

export const dyslexiaMetric = {
  label: 'Dyslexia Risk Indicator (DRI)',
  value: 'DRI',
  scales: [
    {
      value: 'DR',
      label: 'Dyslexia Risk Score',
    },
  ],
  benchmarks: [
    {
      value: 'Dyslexia',
      grades: [0,1,2,3,4,5,6],
      seasons: ['Fall', 'Winter', 'Spring'],
      label: 'Risk Levels',
    },
  ],
  description: '',
}

export function getMetrics(){
  const {sorConfig} = getUserData();

  let metricsToReturn = JSON.parse(JSON.stringify(metrics));

  if(sorConfig.enableDRA && sorConfig.enableLexile) return metricsToReturn;

  metricsToReturn[0].scales = metricsToReturn[0].scales.filter((scale)=>{return !(scale.value === 'DRA' && !sorConfig.enableDRA) && !(scale.value === "Lexile" && !sorConfig.enableLexile)});

  return(metricsToReturn);
}